import { get, uploadForm } from 'store/http/httpAction';
import { addToSelection } from 'components/page/ObjectFilter/components/FieldsSelection/flow/actions';
import { SET_HISTORY_DATA } from './actionType';

const setHistoryData = historyData => ({
  type: SET_HISTORY_DATA,
  payload: { historyData },
});

export const fetchImportHistory = (perPage, currentPage) => dispatch => get('/admin/data-import-jobs', { per_page: perPage, page: currentPage }, dispatch).then(data => {
  if (data) {
    dispatch(setHistoryData(data));
  }
});

export const importFileWithObject = (data, cb) => (dispatch, getState) => uploadForm('/admin/objects/import', data, dispatch).then(res => {
  if (res && res.message) {
    const store = getState();
    const { per_page } = store.setup.fileImport.pagination;
    dispatch(fetchImportHistory(per_page, 1));
    cb();
  }
});

export const fetchImportRequiredFields = objectType => dispatch => get(`/admin/metadata/object/${objectType}/import-required`, {}, dispatch).then(data => {
  if (data && data.data) {
    dispatch(addToSelection(data.data));
  }
});



// WEBPACK FOOTER //
// ./src/views/Setup/ObjectImport/flow/action.js